import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useEffect, useState } from "react";
import { OutputImage } from "../../Components/Shared/OutputImage";
import { HistoryItemReview } from "../../../../Layouts/SuiteHistoryLayout/Shared/HistoryItemReview";
import { ButtonBase, CircularProgress, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { useGetImageSuiteHistoryById } from "../../../../store/Apis/SuitesApps/SuiteHistroyApi";
import {
  ImageAppHistoryItem,
  ImageSuiteApps,
  SuiteApps,
  SuitesApps,
} from "../../../../Helper";
import { SuggestionApp } from "../Layout/ImageSuiteHistoryContainer";
import { ExpandGeneratedImageModal } from "../../Components/Shared/ExpandGeneratedImageModal";
import { InputAndOutputTypes } from "../../../../Types/ImageSuite-types";
import { useImageSuiteGetImageSettings } from "../../../../store/Apis/SuitesApps/ImageSuitesApi";
import { Close } from "@mui/icons-material";
import { ImageLibraryItem } from "../../../InspirationLibrary/InspirationLibraryHelper";
import { VideoDetailsView } from "../../../VideoSuite/Components/Shared/VideoSuiteHelper";

const containerStyle = {
  py: 1.5,
  px: 2.5,
  display: "flex",
  flexDirection: "column",
  width: "80%",
  height: "80%",
  position: "absolute",
  borderRadius: "24px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#2A2C33",
};

const sharedDetailsContainerStyle = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  px: 2,
  py: 1,
  borderRadius: "12px",
};
interface DisplayHistoryItemDataModalProps {
  open: boolean;
  isRegenerateItemLoading: boolean;
  handleClose: () => void;
  handleRegenerateItem: (itemType: string) => void;
  itemId: string;
  regenerateItemOutput: string;
  suggestionsImageApps: SuggestionApp[];
  imageLibraryData?: ImageLibraryItem | null;
  modalView?: number;
}

export const DisplayHistoryItemDataModal = ({
  open,
  handleClose,
  itemId,
  handleRegenerateItem,
  isRegenerateItemLoading,
  regenerateItemOutput,
  suggestionsImageApps,
  imageLibraryData,
  modalView,
}: DisplayHistoryItemDataModalProps) => {
  const [expandImage, setExpandImage] = useState(false);
  const [currentHistoryItem, setCurrentHistoryItem] =
    useState<ImageAppHistoryItem>();
  const [selectedItemId, setSelectedItemId] = useState<string>("");
  const { data: ImageHistoryItemData, isLoading } =
    useGetImageSuiteHistoryById(selectedItemId);
  const btnActionTitle =
    modalView === VideoDetailsView.library
      ? "Generate similar image"
      : "Regenerate";

  const handleGetHistoryItemData = (itemId: string) => {
    setSelectedItemId(itemId);
  };
  useEffect(() => {
    if (open && itemId && modalView !== VideoDetailsView.library) {
      handleGetHistoryItemData(itemId);
    } else if (open && modalView === VideoDetailsView.library) {
      const historyItemData = {
        id: "",
        input: {
          prompt: imageLibraryData?.prompt || "",
          imageUrl: "",
        },
        output: imageLibraryData?.url || "",
        appId: "",
        appType: ImageSuiteApps.ImageGenerator,
        createdAt: "",
        settings: {
          model: "Auto",
          dimension: "1:1",
          seed: 0,
        },
        inputType: 1,
        outputType: 2,
      };
      setCurrentHistoryItem(historyItemData);
    }
  }, [open]);

  useEffect(() => {
    if (ImageHistoryItemData) {
      setCurrentHistoryItem(ImageHistoryItemData);
    }
  }, [ImageHistoryItemData]);

  const handleExpandImage = () => {
    setExpandImage(true);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{ ...containerStyle }}
          className="video-suite-history-details-modal"
        >
          <Box
            className="video-suite-history-details-modal-close-icon"
            sx={{
              mb: 1,
              display: "flex",
              justifyContent: "flex-end",
              width: 1,
            }}
          >
            <ButtonBase onClick={handleClose}>
              <Close
                sx={{
                  fontSize: "24px",
                }}
              />
            </ButtonBase>
          </Box>

          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <CircularProgress size={50} color="primary" />
            </Box>
          ) : (
            <Box
              sx={{
                p: 1,
                display: "flex",
                flexDirection: { xs: "column-reverse", md: "row" },
                overflow: "hidden",
                flexGrow: 1,
                gap: 2,
                width: 1,
                height: 1,
              }}
            >
              <Box
                className="video-details-container"
                sx={{
                  ...sharedDetailsContainerStyle,
                  overflow: "hidden",
                  height: { xs: "50%", md: "100%" },
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {currentHistoryItem?.outputType &&
                (currentHistoryItem.outputType & InputAndOutputTypes.Image) ===
                  InputAndOutputTypes.Image ? (
                  <OutputImage
                    slider={false}
                    outputImage={true}
                    imgUrl={regenerateItemOutput}
                    isLoading={isRegenerateItemLoading}
                    exampleImgUrl={currentHistoryItem?.output || ""}
                    handleOpenExpandImage={handleExpandImage}
                  />
                ) : (
                  <OutputImage
                    slider={false}
                    outputImage={false}
                    imgUrl={
                      regenerateItemOutput || currentHistoryItem?.output || ""
                    }
                    isLoading={isRegenerateItemLoading}
                  />
                )}
              </Box>
              <Box
                className="video-details-container"
                sx={{
                  ...sharedDetailsContainerStyle,
                  overflow: "hidden",
                  height: { xs: "50%", md: "100%" },
                }}
              >
                <HistoryItemReview
                  itemData={currentHistoryItem}
                  handleRegenerateItem={handleRegenerateItem}
                  isLoading={isRegenerateItemLoading}
                  suggestionsImageApps={suggestionsImageApps}
                  btnActionText={btnActionTitle}
                />
              </Box>
            </Box>
          )}
        </Box>
      </Modal>
      {expandImage &&
      currentHistoryItem?.outputType &&
      (currentHistoryItem.outputType & InputAndOutputTypes.Image) ===
        InputAndOutputTypes.Image ? (
        <ExpandGeneratedImageModal
          open={expandImage}
          imgSrc={regenerateItemOutput || currentHistoryItem?.output}
          handleClose={() => setExpandImage(false)}
        />
      ) : null}
    </>
  );
};
